import { memo, useMemo } from "react";

import { SiteControllerType, type RoomPriceRank_RoomPriceRankPageQuery } from "@/lib/gql/__generated__/graphql";

type Props = {
	siteControllerSetting: RoomPriceRank_RoomPriceRankPageQuery["siteControllerSetting"];
};

export const RoomPriceRankSupplementaryInfo = memo(({ siteControllerSetting }: Props) => {
	const { setUpRoomPriceByChillnn, siteControllerType } = siteControllerSetting;

	const shouldSetUpRoomPriceByChillnn =
		siteControllerType === SiteControllerType.NotUsing || setUpRoomPriceByChillnn || false;
	/**
	 * @todo サイコン設定画面が実装されたら、取得した値から => システム用文言への変換は共通のものを使う
	 */
	const usingSettingText = useMemo(
		() =>
			(() => {
				if (shouldSetUpRoomPriceByChillnn) {
					return "CHILLNNで料金管理する";
				}

				switch (siteControllerType) {
					case SiteControllerType.Beds24:
						return "Beds24";
					case SiteControllerType.Neppan:
						return "ねっぱん!";
					case SiteControllerType.Temairazu:
						return "手間いらず";
					case SiteControllerType.TlLincoln:
						return "TL-Lincoln";
					case SiteControllerType.AirHost:
						return "AirHost";
					default:
						siteControllerType satisfies never;
						return "未選択";
				}
			})(),
		[shouldSetUpRoomPriceByChillnn, siteControllerType],
	);

	return (
		<div className="flex flex-col gap-y-6">
			<div className="flex flex-col gap-y-1">
				<p className="text-sm">サイコン設定での設定内容</p>
				<ul className="list-disc pl-5">
					<li>
						<p className="font-semibold">{usingSettingText}</p>
					</li>
				</ul>
			</div>

			{shouldSetUpRoomPriceByChillnn ? (
				<p>このページで部屋料金ランクを設定してください。</p>
			) : (
				<p>サイコンの管理画面で料金の設定、管理をしてください。</p>
			)}
		</div>
	);
});
